import { ButtonHTMLAttributes } from 'react';
import './style.css';

interface IButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  label: string;
  onClick: () => void;
  isReturnButton?: boolean;
  isHighlighted?: boolean;
  props?: ButtonHTMLAttributes<HTMLButtonElement>;
}

export default function ButtonComponent({
  label,
  onClick,
  isReturnButton,
  isHighlighted,
  props,
  ...buttonProps
}: IButtonProps) {
  const baseClass = isReturnButton ? 'button button-return' : 'button';
  const highlightClass = isHighlighted ? 'button-highlighted' : '';

  return (
    <div className="button-container">
      <button
        className={`${baseClass} ${highlightClass}`}
        onClick={() => onClick()}
        {...props}
        {...buttonProps}
      >
        {label}
      </button>
    </div>
  );
}
